import {
  SETTINGS_PROJECT_STATUS_CLEAR_SNACKBAR,
  SETTINGS_GET_PROJECT_STATUS,
  SETTINGS_GET_PROJECT_STATUS_LOADING,
  SETTINGS_DELETE_PROJECT_STATUS_SUCCESS,
  SETTINGS_ADD_PROJECT_STATUS_SUCCESS,
  SETTINGS_ADD_PROJECT_STATUS_ERROR,
  SETTINGS_PROJECT_STATUS_ERROR,
  SETTINGS_GET_PROJECT_STATUS_AUTOCOMPLETE,
  SETTINGS_PROJECT_STATUS_AUTOCOMPLETE_LOADING,
  SETTINGS_PROJECT_STATUS_AUTOCOMPLETE_STATUS_ERROR,
} from "../constants/types";

// import { BULK_UPLOAD_FILE_SUCCESS } from "../constants/documentsConstants";

const initialState = {
  projectStatus: [],
  loading: true,
  status: "success",
  text: "",
  showSnackbar: false,
};

const projectStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_PROJECT_STATUS_CLEAR_SNACKBAR:
      return {
        ...state,
        showSnackbar: false,
      };
    case SETTINGS_GET_PROJECT_STATUS:
      return {
        ...state,
        ...action.payload,
        showSnackbar: false,
      };
    case SETTINGS_GET_PROJECT_STATUS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SETTINGS_DELETE_PROJECT_STATUS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_PROJECT_STATUS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_PROJECT_STATUS_ERROR:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_PROJECT_STATUS_ERROR:
      return {
        ...state,
        // warranties: [],
        loading: false,
        status: action.payload.status,
        text: action.payload.text,
        showSnackbar: true,
      };

    default:
      return state || {};
  }
};

export default projectStatusReducer;
